import { render } from "./UserPage.vue?vue&type=template&id=84a44068&ts=true"
import script from "./UserPage.vue?vue&type=script&lang=ts"
export * from "./UserPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__